import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { sendNotification } from "src/redux/actions/notifications";
import { addExperience, deleteExperience, findAllExperience } from "src/redux/actions/experience";
import { withRouter, Link } from "react-router-dom";
import { findAllSites } from 'src/redux/actions/sites';
import { addStock, deleteStock, findAllStock } from 'src/redux/actions/stock';
import { findAllUsers } from 'src/redux/actions/admin';

class Experience extends Component {
  render = () => {
    const {
      Layout,
      experience,
      user,
      findAllExperience,
      addExperience,
      deleteExperience,
      findAllSites,
      sites,
      stock,
      findAllStock,
      findAllUsers,
      addStock,
      deleteStock,
      sendNotification,
      push,
      history,
      findAllExperienceUpdatedToday,
    } = this.props;
    return (
      <Layout
        experience={experience}
        user={user}
        addExperience={addExperience}
        stock={stock}
        findAllStock={findAllStock}
        findAllUsers={findAllUsers}
        addStock={addStock}
        deleteStock={deleteStock}
        findAllExperience={findAllExperience}
        deleteExperience={deleteExperience}
        sendNotification={sendNotification}
        findAllSites={findAllSites}
        sites={sites}
        push={push}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  experience: state.experience.allExperience || [],
  stock: state.stock.allStock || [],
  sites: state.sites.allSites,
  user: state.user.user || {},
});

const mapDispatchToProps = {
  findAllStock,
  findAllUsers,
  addStock,
  deleteStock,
  addExperience,
  deleteExperience,
  findAllExperience,
  sendNotification,
  findAllSites,
  push,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Experience)
);
